import {Interceptor} from '@jobseeker/common-core/lib/components/Inteceptor';
import {NavLayout, ResponsiveLayout, SeoLayout} from '@layouts';
import {getConfigByApp, utilServerSideDeviceDetection} from '@utils';
import {metaInfo} from '@configs';
import {HOME, TERMS} from '@constants';
import loadSEO from '@helpers/loadSEO';
import {wrapper} from '@jobseeker/common-core/lib/stores';
import {VersionVariants} from '@jobseeker/lotus/lib/enums/variants';
import TermsPage from '@components/Static/Terms';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import useValidateAuth from '@jobseeker/common-core/lib/hooks/useValidateAuth';
import {TrackEventUBA} from '@jobseeker/common-core/lib/utils';
import {useRouter} from 'next/router';
import {useEffect} from 'react';
import dynamic from 'next/dynamic';
import {AppState} from '@jobseeker/common-core/lib/types';
import {isCSR} from '@jobseeker/lotus/lib/utils';
import {InjectSearchOverlay} from '@components';
import {BaseContext} from 'next/dist/shared/lib/utils';

type TermsProps = {
  seoConfig: object;
  isMobile?: boolean;
};
const HiristAuthentication = dynamic(
  () =>
    import(
      '@jobseeker/client-harness/lib/components/HiristAuthenticationHarness/AuthForm'
    ),
  {
    ssr: false,
  }
);
const Terms = ({seoConfig, isMobile}: TermsProps) => {
  const metaData = getConfigByApp(metaInfo, HOME, true, TERMS);

  const dispatch =
    /* eslint-disable @typescript-eslint/no-explicit-any */ useDispatch<any>();

  useValidateAuth(dispatch);

  const {searchOverlay, enableLoginPopup} = useSelector(
    (state: AppState) => state.app.layout,
    shallowEqual
  );
  const isSearchEnabled = useSelector(() => searchOverlay, shallowEqual);
  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';
  const breadcrumbElements = isAppIimjobs
    ? [
        {
          name: 'Home',
          item: '/',
        },
        {
          name: 'Terms and Conditions',
          item: ``,
        },
      ]
    : [];
  const onLoginSuccess = () => {
    if (isCSR()) {
      window.location.reload();
    }
  };
  const router = useRouter();
  useEffect(() => {
    TrackEventUBA('termsPageView', 'view', {
      ref: router.query.ref || '',
      pageName: 'Terms Page',
      sessionUsername: `${sessionStorage.getItem('userId')}`,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Interceptor metaInfo={metaData}>
      <SeoLayout seoConfig={seoConfig} />
      <NavLayout>
        <ResponsiveLayout
          breadcrumbElements={breadcrumbElements}
          variant={VersionVariants.VERSION_TWO}
        >
          {!isAppIimjobs && (
            <HiristAuthentication
              variant={VersionVariants.VERSION_TWO}
              onSuccess={onLoginSuccess}
              openDialog={enableLoginPopup}
              setOpenDialog={() => {
                dispatch({
                  type: 'AppContext/set_login_popup',
                  payload: false,
                });
              }}
            />
          )}
          <InjectSearchOverlay isSearchEnabled={isSearchEnabled} />
          <TermsPage isMobile={isMobile} />
        </ResponsiveLayout>
      </NavLayout>
    </Interceptor>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  store => async (context: BaseContext) => {
    const seoConfig = await loadSEO(TERMS);
    const {isMobile} = utilServerSideDeviceDetection(context);

    store.dispatch({
      type: 'AppContext/set_current_page',
      payload: {page: TERMS},
    });

    return {
      props: {
        seoConfig,
        isMobile,
      },
    };
  }
);

export default Terms;
